import React from 'react'
import IconBase from '../IconBase'

const svgContent = <svg width="1em" height="1em" viewBox="0 0 16 16" focusable="false" fill="currentColor" aria-hidden="true"><path d="M1.777 14.223h3.556v-3.556H1.777v3.556ZM.89 8.889h5.334c.49 0 .888.398.888.888v5.334a.89.89 0 0 1-.888.889H.889A.89.89 0 0 1 0 15.11V9.778c0-.49.397-.888.89-.888Zm9.778 5.334h3.556v-3.556h-3.556v3.556Zm-.89-5.334h5.334c.492 0 .889.398.889.888v5.334a.89.89 0 0 1-.89.889H9.778a.89.89 0 0 1-.888-.89V9.778c0-.49.398-.888.888-.888Zm.89-7.112v3.556h3.556V1.777h-3.556ZM9.777 0h5.334c.492 0 .889.397.889.89v5.333a.89.89 0 0 1-.89.888H9.778a.89.89 0 0 1-.888-.888V.889c0-.492.398-.889.888-.889Zm-8 5.333h3.556V1.777H1.777v3.556ZM.89 0h5.334c.49 0 .888.397.888.89v5.333a.89.89 0 0 1-.888.888H.889A.89.89 0 0 1 0 6.223V.889C0 .397.397 0 .89 0Z" fill="#646473" fillRule="nonzero" /></svg>

const Select = React.forwardRef((props, ref) => {
  return (
    <IconBase name="select" {...props} ref={ref}>
      {svgContent}
    </IconBase>
  )
})

Select.displayName = 'IconSelect'

export default Select
